import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import Badge from '../../components/atoms/Badge';
import { STATUS_LABEL_KEYS, STATUSES } from '../consts';

const getStatusBadgeVariant = status => {
    switch (status) {
        case STATUSES.DRAFT:
            return 'warning';
        case STATUSES.SUBMITTED:
        case STATUSES.IN_REVIEW:
            return 'active';
        case STATUSES.APPROVED:
            return 'success';
        case STATUSES.REJECTED:
        case STATUSES.DELETED:
            return 'error';
        default:
            return 'light';
    }
};

const StatusBadge = ({ status }) => (
    <Badge variant={getStatusBadgeVariant(status)}>
        <Translate id={STATUS_LABEL_KEYS[status]} />
    </Badge>
);

StatusBadge.propTypes = {
    status: PropTypes.string.isRequired,
};

export default StatusBadge;
